import * as actionTypes from "./actionTypes";
import { GET_STORE_CONFIG_URL, GET_STORE_BY_SLUG_URL, GET_BRAND_LOCATIONS_URL } from "../../configs";
import Axios from "axios";

/**
 * Get single store configuration by unique slug
 * Optionally pass coordinates to get nearest restaurant for brand
 */
export const getSingleStoreConfig = (uniqueSlug) => (dispatch) => {
	dispatch({ type: actionTypes.GET_SINGLE_STORE_CONFIG });

	// Get user's location coordinates if available
	const userSetAddress = localStorage.getItem("userSetAddress");
	let params = {};
	
	if (userSetAddress) {
		try {
			const location = JSON.parse(userSetAddress);
			console.log('📍 getSingleStoreConfig: Parsed userSetAddress:', location);
			
			// Validate coordinates are present and valid numbers
			const lat = parseFloat(location.lat);
			const lng = parseFloat(location.lng);
			
			if (location.lat && location.lng && !isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0) {
				params = {
					latitude: lat,
					longitude: lng
				};
				console.log(`📍 getSingleStoreConfig: Sending coordinates to API`, params);
			} else {
				console.warn('📍 getSingleStoreConfig: Invalid coordinates in userSetAddress', {
					lat: location.lat,
					lng: location.lng,
					parsedLat: lat,
					parsedLng: lng
				});
			}
		} catch (e) {
			console.error("Error parsing userSetAddress:", e, userSetAddress);
		}
	} else {
		console.warn('📍 getSingleStoreConfig: No userSetAddress in localStorage');
	}

	console.log(`🔄 API Call: GET ${GET_STORE_CONFIG_URL}/${uniqueSlug}`, params);
	return Axios.get(`${GET_STORE_CONFIG_URL}/${uniqueSlug}`, { params })
		.then((response) => {
			const data = response.data;
			if (data.success) {
				const restaurant = data.data.restaurant;
				const brand = data.data.brand;
				
				
				// Check if restaurant changed
				const previousRestaurantId = localStorage.getItem("restaurantId");
				const restaurantChanged = previousRestaurantId && previousRestaurantId !== restaurant.id.toString();
				
				// Brand is valid - save it for future redirects
				if (brand && brand.unique_id) {
					localStorage.setItem('lastVisitedBrand', brand.unique_id);
					// Also save as last valid brand for fallback
					localStorage.setItem('lastValidBrand', brand.unique_id);
				}
				
				// Populate localStorage with essential restaurant/brand settings
				if (restaurant) {
					// Store basic restaurant info
					localStorage.setItem("storeColor", "#2ecc71"); // Default color, should come from brand
					localStorage.setItem("storeName", restaurant.name);
					localStorage.setItem("storeLogo", brand && brand.logo ? `${window.location.origin}/assets/${brand.logo}` : "");
					localStorage.setItem("restaurantSlug", restaurant.slug);
					localStorage.setItem("restaurantId", restaurant.id);
					localStorage.setItem("restaurant_unique_slug", uniqueSlug);
					
					// // Store default location (latitude/longitude) from restaurant
					// if (restaurant.latitude && restaurant.longitude) {
					// 	const defaultLocation = {
					// 		latitude: parseFloat(restaurant.latitude),
					// 		longitude: parseFloat(restaurant.longitude),
					// 		address: restaurant.address || restaurant.name || "Default Location",
					// 		name: restaurant.name || "Default Location",
					// 		city: restaurant.city || null,
					// 		state: restaurant.state || null,
					// 		pincode: restaurant.pincode || null,
					// 		landmark: restaurant.landmark || null
					// 	};
					// 	localStorage.setItem("storeDefaultLocation", JSON.stringify(defaultLocation));
						
					// 	console.log("📍 Store Default Location Set:", {
					// 		latitude: defaultLocation.latitude,
					// 		longitude: defaultLocation.longitude,
					// 		address: defaultLocation.address
					// 	});
						
					// 	// If no userSetAddress exists, set this as default
					// 	if (!localStorage.getItem("userSetAddress")) {
					// 		const userSetAddress = {
					// 			lat: defaultLocation.latitude,
					// 			lng: defaultLocation.longitude,
					// 			address: defaultLocation.address,
					// 			house: null,
					// 			tag: null,
					// 			city: defaultLocation.city,
					// 			state: defaultLocation.state,
					// 			businessLocation: true,
					// 		};
					// 		localStorage.setItem("userSetAddress", JSON.stringify(userSetAddress));
					// 		localStorage.setItem("userAlreadySelectedLocation", "true");
					// 	}
					// }
					
					// Store WhatsApp number from restaurant.phone field
					if (restaurant.phone) {
						// Extract phone number (remove + and spaces, keep digits)
						const whatsappPhone = restaurant.phone.replace(/\D/g, '');
						if (whatsappPhone.length >= 10) {
							localStorage.setItem("whatsappContactNumber", whatsappPhone);
							localStorage.setItem("supportContactNumber", whatsappPhone);
							console.log("📱 WhatsApp Number Set from restaurant.phone:", whatsappPhone);
						}
					}
					
					// Parse and store phone number list if available (for future use)
					if (restaurant.phone_list) {
						const phoneList = restaurant.phone_list;
						// Parse format: "Indira (Billing)9876543210, karthika (manager)- 7358320321"
						const phoneEntries = phoneList.split(',').map(entry => {
							const trimmed = entry.trim();
							// Match pattern: "Name (Role)Phone" or "Name - Phone" or just "Phone"
							const match = trimmed.match(/(.+?)\s*(?:\(([^)]+)\)|-\s*)?(\d{10,})/);
							if (match) {
								return {
									name: match[1].trim(),
									role: match[2] ? match[2].trim() : null,
									phone: match[3].replace(/\D/g, '')
								};
							}
							// Fallback: just extract phone number
							const phoneOnly = trimmed.replace(/\D/g, '');
							if (phoneOnly.length >= 10) {
								return {
									name: null,
									role: null,
									phone: phoneOnly
								};
							}
							return null;
						}).filter(entry => entry && entry.phone);
						
						if (phoneEntries.length > 0) {
							// Store all phone entries for reference
							localStorage.setItem("storePhoneNumberList", JSON.stringify(phoneEntries));
						}
					}
					
					// // Store customer details dynamically
					// const customerDetails = {
					// 	storeName: restaurant.name,
					// 	storeAddress: restaurant.address || null,
					// 	storeCity: restaurant.city || null,
					// 	storeState: restaurant.state || null,
					// 	storePincode: restaurant.pincode || null,
					// 	storePhone: restaurant.phone || null,
					// 	storeEmail: restaurant.email || null,
					// 	latitude: restaurant.latitude ? parseFloat(restaurant.latitude) : null,
					// 	longitude: restaurant.longitude ? parseFloat(restaurant.longitude) : null,
					// 	landmark: restaurant.landmark || null,
					// };
					// localStorage.setItem("storeCustomerDetails", JSON.stringify(customerDetails));
					
					// console.log("📋 Store Customer Details Set:", {
					// 	name: customerDetails.storeName,
					// 	phone: customerDetails.storePhone,
					// 	latitude: customerDetails.latitude,
					// 	longitude: customerDetails.longitude
					// });
					
					// // Log if restaurant changed
					// if (restaurantChanged) {
					// 	console.log(`🔄 Restaurant switched to nearest location: ${restaurant.name} (ID: ${restaurant.id})`);
					// }
					
					// Store brand info
					if (brand) {
						localStorage.setItem("brandId", brand.id);
						localStorage.setItem("brandName", brand.name);
						localStorage.setItem("brandUniqueId", brand.unique_id);
						// Store brand hero image for first screen
						if (brand.hero_image) {
							const heroImageUrl = `${window.location.origin}/assets/${brand.hero_image}`;
							localStorage.setItem("brandHeroImage", heroImageUrl);
						} else {
							// Clear brandHeroImage if brand doesn't have one
							localStorage.removeItem("brandHeroImage");
						}
					}
					
				// Set default values if not already set
				if (!localStorage.getItem("currencyFormat")) {
					localStorage.setItem("currencyFormat", "₹");
				}
				if (!localStorage.getItem("currencySymbolAlign")) {
					localStorage.setItem("currencySymbolAlign", "left");
				}
				if (!localStorage.getItem("googleApiKey")) {
					localStorage.setItem("googleApiKey", "AIzaSyCQ7CSjntyXx84YgDs5vVvzZFCVAmQk_XY");
				}
					
				// Set default UI strings
				localStorage.setItem("searchAreaPlaceholder", "Search for area, street name...");
				localStorage.setItem("deliveryTypeDelivery", "Delivery");
				localStorage.setItem("deliveryTypeSelfPickup", "Self Pickup");
				localStorage.setItem("restaurantCountText", "Restaurants");
				localStorage.setItem("homePageMinsText", "mins");
				localStorage.setItem("restaurantNotActiveMsg", "Restaurant is not accepting orders");
				localStorage.setItem("noRestaurantMessage", "No restaurants available in your area");
				localStorage.setItem("mockSearchPlaceholder", "Search for restaurants or items");
				localStorage.setItem("enSPU", "true"); // Enable self-pickup
				localStorage.setItem("showPromoSlider", "true");
				localStorage.setItem("mockSearchOnHomepage", "true");
				localStorage.setItem("showRestaurantCategorySliderLabel", "true");
				localStorage.setItem("restaurantCategorySliderSize", "5");
				localStorage.setItem("restaurantCategorySliderStyle", "1");
				localStorage.setItem("hideDesktopView", "true"); // Force mobile view for brand site
				
				// SEO Settings
				localStorage.setItem("seoMetaTitle", brand ? brand.name : restaurant.name);
				localStorage.setItem("seoMetaDescription", brand ? brand.description || `Order from ${brand.name}` : restaurant.description);
				localStorage.setItem("seoOgTitle", brand ? brand.name : restaurant.name);
				localStorage.setItem("seoOgDescription", brand ? brand.description || `Order from ${brand.name}` : restaurant.description);
				localStorage.setItem("seoTwitterTitle", brand ? brand.name : restaurant.name);
				localStorage.setItem("seoTwitterDescription", brand ? brand.description || `Order from ${brand.name}` : restaurant.description);
				
				// Other essential settings
				localStorage.setItem("showGdpr", "false");
				localStorage.setItem("gdprAccepted", "true");
				localStorage.setItem("enIOSPWAPopup", "false");
				localStorage.setItem("enablePushNotification", "false");
			}
				
				dispatch({
					type: actionTypes.GET_SINGLE_STORE_CONFIG_SUCCESS,
					payload: data.data,
				});
				return data.data;
			} else {
				dispatch({
					type: actionTypes.GET_SINGLE_STORE_CONFIG_ERROR,
					payload: data.message,
				});
				return null;
			}
		})
		.catch((error) => {
			console.error("Error fetching store config:", error);
			dispatch({
				type: actionTypes.GET_SINGLE_STORE_CONFIG_ERROR,
				payload: error.message,
			});
			return null;
		});
};

/**
 * Get restaurant by unique slug with geolocation
 */
export const getStoreByLocation = (uniqueSlug, latitude, longitude) => (dispatch) => {
	dispatch({ type: actionTypes.GET_STORE_BY_LOCATION });

	return Axios.post(`${GET_STORE_BY_SLUG_URL}/${uniqueSlug}`, {
		latitude,
		longitude,
	})
		.then((response) => {
			const data = response.data;
			if (data.success) {
				// Store brand hero image if available
				if (data.brand && data.brand.hero_image) {
					const heroImageUrl = `${window.location.origin}/assets/${data.brand.hero_image}`;
					localStorage.setItem("brandHeroImage", heroImageUrl);
					console.log('✅ Stored brandHeroImage (getStoreByLocation):', heroImageUrl);
				} else {
					// Clear brandHeroImage if brand doesn't have one
					localStorage.removeItem("brandHeroImage");
				}
				
				dispatch({
					type: actionTypes.GET_STORE_BY_LOCATION_SUCCESS,
					payload: data,
				});
				return data;
			} else {
				dispatch({
					type: actionTypes.GET_STORE_BY_LOCATION_ERROR,
					payload: data.message,
				});
				return null;
			}
		})
		.catch((error) => {
			console.error("Error fetching store by location:", error);
			dispatch({
				type: actionTypes.GET_STORE_BY_LOCATION_ERROR,
				payload: error.message,
			});
			return null;
		});
};

/**
 * Get all locations for a brand
 */
export const getBrandLocations = (uniqueSlug, latitude, longitude) => (dispatch) => {
	dispatch({ type: actionTypes.GET_BRAND_LOCATIONS });

	return Axios.post(`${GET_BRAND_LOCATIONS_URL}/${uniqueSlug}`, {
		latitude,
		longitude,
	})
		.then((response) => {
			const data = response.data;
			console.log('🔍 getBrandLocations API Response:', data);
			
			if (data.success) {
				// Ensure locations is always an array, even if API returns null/undefined
				const nestedLocations =
					data && data.data && data.data.locations ? data.data.locations : null;
				const locations = data.locations || nestedLocations || [];
				console.log('📍 Locations extracted:', locations.length, locations);
				
				dispatch({
					type: actionTypes.GET_BRAND_LOCATIONS_SUCCESS,
					payload: {
						...data,
						locations: locations
					},
				});
				return { ...data, locations };
			} else {
				dispatch({
					type: actionTypes.GET_BRAND_LOCATIONS_ERROR,
					payload: data.message,
				});
				return null;
			}
		})
		.catch((error) => {
			console.error("Error fetching brand locations:", error);
			dispatch({
				type: actionTypes.GET_BRAND_LOCATIONS_ERROR,
				payload: error.message,
			});
			return null;
		});
};

/**
 * Set restaurant slug from URL
 */
export const setRestaurantSlug = (slug) => (dispatch) => {
	dispatch({
		type: actionTypes.SET_RESTAURANT_SLUG,
		payload: slug,
	});
};

